/**
 * Auth module that switches between real Cognito auth and dev mode mock auth.
 */
import { isDemoMode, isDevMode } from "../config";
import * as realAuth from "./cognito";
import * as devAuth from "./dev-auth";
import * as demoAuth from "./demo-auth";

// Re-export the appropriate implementation: demo (role picker, client storage)
// takes precedence, then local dev mock, else real Cognito.
const auth = isDemoMode() ? demoAuth : isDevMode() ? devAuth : realAuth;

export const startSignIn = auth.startSignIn;
export const completeSignIn = auth.completeSignIn;
export const signOut = auth.signOut;
export const isSignedIn = auth.isSignedIn;
export const getClaims = auth.getClaims;
export const getIdToken = auth.getIdToken;

// Passkeys (issue #43)
export const passkeySupported = auth.passkeySupported;
export const shouldOfferEnrollment = auth.shouldOfferEnrollment;
export const markEnrolled = auth.markEnrolled;
export const markDontAsk = auth.markDontAsk;
export const checkPasskeyAvailable = auth.checkPasskeyAvailable;
export const signInWithPasskey = auth.signInWithPasskey;
export const enrollPasskey = auth.enrollPasskey;
